import { FDCQuickLinks } from '../../../cimsPage/instances/fdc'
import { QuickLinks } from '../../common'

const quickLinks = QuickLinks({
  page: FDCQuickLinks,
  create: '28C149CB-2564-435F-B2A5-DF03BDA2806D',
  view: '1E4B155A-4310-4C6C-B8B6-5E2FE90B39CE',
  edit: '23DD887F-B5B7-48CA-9886-0C44FEA4D2C3',
  removeRestore: '2B7C9B0B-8C06-48EE-AAED-2C3301501D69',
})

export const CreateFDCQuickLink = quickLinks.Create
export const ViewFDCQuickLink = quickLinks.View
export const EditFDCQuickLink = quickLinks.Edit
export const RemoveRestoreFDCQuickLink = quickLinks.RemoveRestore

export type FDCQuickLinkPermission =
  | typeof CreateFDCQuickLink
  | typeof ViewFDCQuickLink
  | typeof EditFDCQuickLink
  | typeof RemoveRestoreFDCQuickLink
